import React from 'react';
import { motion } from 'framer-motion';
import Button from './ui/Button';

const Investment = () => {
  return (
    <section className="py-24 bg-deep-charcoal text-vintage-white">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-serif mb-6">
            Wedding Investment and Starting Minimums
          </h2>
          <div className="w-16 h-px bg-estate-bronze mx-auto mb-8"></div>
          <p className="text-lg text-vintage-white/80 font-light leading-relaxed max-w-3xl mx-auto">
            At Padua Weddings, event minimums typically begin around $16,000 for select weekday events. We believe in providing an elevated experience that feels both grand and approachable, with transparent pricing to help you plan with confidence.
          </p>
        </div>

        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="bg-vintage-white/5 border border-white/10 rounded-2xl p-8 md:p-12 mb-12 backdrop-blur-sm"
        >
          <h3 className="text-xl font-medium mb-8 text-center uppercase tracking-widest text-warm-stone text-sm">
            General Planning Guidance
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-2xl mx-auto">
            <div className="flex justify-between items-center border-b border-white/10 pb-4">
              <span className="font-serif text-xl">Weekday Events</span>
              <span className="font-light text-estate-bronze">from $16,000</span>
            </div>
            <div className="flex justify-between items-center border-b border-white/10 pb-4">
              <span className="font-serif text-xl">Friday Events</span>
              <span className="font-light text-estate-bronze">from $23,000</span>
            </div>
            <div className="flex justify-between items-center border-b border-white/10 pb-4">
              <span className="font-serif text-xl">Saturday Events</span>
              <span className="font-light text-estate-bronze">from $31,000</span>
            </div>
            <div className="flex justify-between items-center border-b border-white/10 pb-4">
              <span className="font-serif text-xl">Sunday Events</span>
              <span className="font-light text-estate-bronze">from $20,000</span>
            </div>
          </div>

          <p className="mt-10 text-sm text-vintage-white/60 font-light text-center italic max-w-2xl mx-auto leading-relaxed">
            * These starting points are intended to help couples understand general investment expectations. Final proposals vary based on guest count, date, and selected services.
          </p>
        </motion.div>

        <div className="text-center">
          <Button href="https://tour.paduaweddings.com" variant="primary" className="bg-estate-bronze hover:bg-estate-bronze/90 text-white border-none">
            Review Your Wedding Estimate
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Investment;